module.exports = require("core-js/library/fn/number/min-safe-integer");